/**
 * Array module.
 * @module src/function
 */

/**
 * Returns if the argument is a function or not
 *
 * @function isFunction
 *
 * @param {any} func - element to be checked.
 * @return {boolean} if the element is a function or not.
 *
 * @example
 * isFunction('');
 * // returns false
 *
 * @example
 * isFunction(number => number * 2);
 * // returns true
 */
export const isFunction = func => typeof func === 'function';